import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  GetWIFIDetailsRequest,
  GetWIFIObservationDetailsRequest,
  GetWIFIObservationDetailsResponse,
  GetWifiObservationsSurveyedOrConnectedRequest,
  GetWifiObservationsSurveyedOrConnectedResponse,
  WifiDetailResponse
} from '@types';
import { sec } from './security';
const { VITE_API_HOST } = import.meta.env;

// Define a service using a base URL and expected endpoints
export const wifiService = createApi({
  reducerPath: 'wifiService',
  baseQuery: fetchBaseQuery({
    baseUrl: VITE_API_HOST,
    prepareHeaders: async (headers) => {
      const access_token = await sec.getAccessTokenSilently()();
      if (access_token) headers.set('Authorization', `Bearer ${access_token}`);
      return headers;
    }
  }),
  endpoints: (builder) => ({
    getWIFIDetails: builder.query<WifiDetailResponse, GetWIFIDetailsRequest>({
      query: ({ cluster_id, wifi_bssid, bounds_wkt }) => {
        const params: Record<string, string> = {
          cluster_id,
          wifi_bssid,
          pretty_columns: 'false',
          limit: '1000'
        };

        if (bounds_wkt) {
          params.bounds_wkt = bounds_wkt;
        }

        return {
          url: '/v1/wifi/localized/',
          headers: {
            Accept: 'application/json'
          },
          method: 'GET',
          params
        };
      }
    }),
    getWifiObservationDetails: builder.query<GetWIFIObservationDetailsResponse[], GetWIFIObservationDetailsRequest>({
      query: ({ cluster_id, wifi_bssid, latitude, longitude, min_date, max_date }) => ({
        url: '/wifi/observations/in_cluster/',
        headers: {
          Accept: 'application/json'
        },
        method: 'GET',
        params: {
          cluster_id,
          wifi_bssid,
          longitude,
          latitude,
          min_date,
          max_date,
          summarize: 'true'
        }
      })
    }),
    getWifiObservationsSurveyedOrConnected: builder.query<GetWifiObservationsSurveyedOrConnectedResponse[], GetWifiObservationsSurveyedOrConnectedRequest>({
      query: ({ cluster_id, wifi_bssid, observation_type, bounds_wkt }) => {
        const params: Record<string, string> = {
          bounds_wkt,
          wifi_bssid,
          cluster_id
        };

        if (observation_type) {
          params.observation_type = observation_type;
        }

        return {
          url: '/wifi/observations/',
          headers: {
            Accept: 'application/json'
          },
          method: 'GET',
          params
        };
      }
    })
  })
});

export const {
  //
  useGetWIFIDetailsQuery,
  useGetWifiObservationDetailsQuery,
  useLazyGetWifiObservationDetailsQuery,
  useLazyGetWifiObservationsSurveyedOrConnectedQuery
} = wifiService;
